<template lang='pug'>
#app
  router-view
</template>
<script>
export default {
  created() {
    if (!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
      document.body.style['max-width'] = '375px'
    }
    window.addEventListener('YDUIStyleChange', (param) => {
      if (param.detail === 'dark') {
        document.body.classList.add('dark');
      } else {
        document.body.classList.add('light');
      }
    });
    window.setYDUIStyle(navigator.userAgent.indexOf('YDUIStyle/Dark') > -1 ? 'dark' : 'light');
  },
};
</script>
